import axios from 'axios';
import { stringify } from 'querystring';

import {
  API_URL,
  API_CONTEXT,
} from 'settings';
import { getCurrentSessionData } from 'utils/aws/cognito';
import { SERVICES } from 'services/dynamicore/constants';

// Endpoints whose 403 is a business response, not an expired session
const IGNORE_FORBIDDEN_URLS = [
  SERVICES.MARKETPLACE_STP_CLABES_QUERY,
];

const http = axios.create({
  baseURL: API_URL,
});

http.interceptors.request.use((config) => {
  const { accessToken } = getCurrentSessionData();
  config.headers.Authorization = accessToken;

  if (API_CONTEXT) {
    config.headers.context = API_CONTEXT;
  }

  return config;
});

http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 403) {
      const isIgnoredUrl = IGNORE_FORBIDDEN_URLS
        .some((url) => error?.config?.url?.startsWith(url));
      const {
        hash = '',
        pathname,
        search = '',
      } = window.location;
      const query = {};

      if (!isIgnoredUrl && !pathname.startsWith('/auth/')) {
        query.redirect = Buffer
          .from(`${pathname}${search}${hash}`)
          .toString('base64');
        window.location = `/auth/login?${stringify(query)}`;
      }
    }

    return Promise.reject(error);
  },
);

export default http;
